window.vermoegenswertBuz = {
    data: new Map(),

    versicherungsleistung: function () {
        return this.highchartWerte("versicherungsleistung");
    },

    beitrag_beitragsbefreiung: function () {
        return this.highchartWerte("beitrag_beitragsbefreiung");
    },

    beitrag_burente: function () {
        return this.highchartWerte("beitrag_burente");
    },

    // PRIVATE
    highchartWerte: function (kategorie) {
        const result = [];
        this.data.forEach((value, key) => result.push([key, value[kategorie]]));

        return result;
    },
};

window.buzChart = {
    init: function () {
        this.chart = new Highcharts.stockChart("chart_buz", {
            legend: {
                enabled: true,
            },

            plotOptions: {
                area: {
                    dataGrouping: {
                        approximation: "sum",
                    },
                },
            },

            series: this.chartdata(),
        });
    },

    update: function () {
        if (typeof this.chart !== "undefined") {
            this.chart.showLoading();

            this.chartdata().forEach(
                function (serie) {
                    this.chart.get(serie.id).setData(serie.data, false);
                }.bind(this)
            );

            this.chart.redraw({ duration: chartAnimationDuration });
            this.chart.hideLoading();
        }
    },

    chartdata: () => {
        return [
            {
                name: "Gesamte Versicherungsleistung",
                id: "leistung",
                legendName: "Gesamte Versicherungsleistung",
                yAxis: 0,
                type: "area",
                color: farbeLeistung,
                opacity: "0.5",
                zIndex: 0,
                data: vermoegenswertBuz.versicherungsleistung(),
            },
            {
                name: "Beitrag zur BU-Rente",
                id: "burente",
                legendName: "Beitrag zur BU-Rente",
                yAxis: 0,
                type: "column",
                color: farbeBeitrag1,
                zIndex: 0,
                data: vermoegenswertBuz.beitrag_burente(),
            },
            {
                name: "Beitrag zur Beitragsbefreiung",
                id: "beitragsbefreiung",
                legendName: "Beitrag zur Beitragsbefreiung",
                yAxis: 0,
                type: "column",
                color: farbeBeitrag2,
                zIndex: 0,
                data: vermoegenswertBuz.beitrag_beitragsbefreiung(),
            },
        ];
    },
};
